import {AccordionComponent, DefaultAccordionOptions} from "../../../includes/Components/Accordion/AccordionComponent";

if(window.pew) {
  window.pew.addRegistryEntry({
    key: 'wdf-accordion',
    domSelector: DefaultAccordionOptions.defaultSelector,
    classDef: AccordionComponent
  });
}
